import {RobotSlot, RobotSlots} from "./RobotModel";
import {array} from "../../Core/Reflection";
import {AssemblyBody, AssemblyItem} from "./AssemblyItem";
import {Assembly} from "./Assembly";

export class Robot extends Assembly<RobotSlot> {

    readonly [RobotSlot.Head] = array(() => this.addChild(new AssemblyItem(RobotSlot.Head)));
    readonly [RobotSlot.Body] = array(() => this.addChild(new AssemblyBody(RobotSlot.Body)));
    readonly [RobotSlot.LeftArm] = array(() => this.addChild(new AssemblyItem(RobotSlot.LeftArm)));
    readonly [RobotSlot.RightArm] = array(() => this.addChild(new AssemblyItem(RobotSlot.RightArm)));
    readonly [RobotSlot.LeftLeg] = array(() => this.addChild(new AssemblyItem(RobotSlot.LeftLeg)));
    readonly [RobotSlot.RightLeg] = array(() => this.addChild(new AssemblyItem(RobotSlot.RightLeg)));

    constructor() {
        super(RobotSlots);
    }

    protected getBodyItems(): AssemblyBody<RobotSlot>[] {
        return this[RobotSlot.Body];
    }

    protected getSlotItems(slot: RobotSlot): AssemblyItem<RobotSlot>[] {
        return this[slot];
    }
}